export enum Role {
  Trader = 'trader',
  Partner = 'partner',
  Investor = 'investor',
  Exchanger = 'exchanger',
  TradingPlatform = 'tp'
}
